export default "__VITE_ASSET__O9cEMUF6__"